import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="policy-page">
      <Header />
      <div className="policy-container">
        <h1 className="policy-title">Returns & Exchanges</h1>
        <p className="policy-date">Last updated: April 2026</p>

        <div className="policy-content">
          <section className="policy-section">
            <h3 className="section-title">1. Return Policy</h3>
            <p className="section-text">
              We want you to be completely satisfied with your Liiskerlane
              purchase. If you're not happy with your order, we offer
              hassle-free returns within 30 days of purchase.
            </p>
            <p className="section-text">
              <strong>Return Window:</strong> Items must be returned within 30
              days of the original purchase date.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">2. Return Conditions</h3>
            <p className="section-text">
              To be eligible for a return, items must meet the following
              conditions:
            </p>
            <ul className="section-list">
              <li>Items must be in original, unused condition</li>
              <li>All original tags and packaging must be intact</li>
              <li>No signs of wear or damage</li>
              <li>Items must not have been washed or altered</li>
              <li>
                Proof of purchase (order number or receipt) must be provided
              </li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">3. How to Initiate a Return</h3>
            <p className="section-text">To start a return:</p>
            <ol className="section-list">
              <li>
                Contact our customer service team at trade@liiskerlane.digital
                with your order number
              </li>
              <li>Provide a reason for the return</li>
              <li>Receive a prepaid return shipping label</li>
              <li>Pack the item securely and ship it back to us</li>
              <li>
                Once received and inspected, your refund will be processed
              </li>
            </ol>
          </section>

          <section className="policy-section">
            <h3 className="section-title">4. Refunds</h3>
            <p className="section-text">
              Refunds will be issued to your original payment method within 5-10
              business days of us receiving and inspecting your return. Please
              note that the original shipping cost is non-refundable. Return
              shipping is free for all domestic returns.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">5. Exchanges</h3>
            <p className="section-text">
              Need a different size or color? We offer free exchanges for all
              domestic orders. Simply contact us with your order number and let
              us know what you'd like to exchange. We'll send you a prepaid
              return label and ship your replacement item at no additional cost.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">6. Non-Returnable Items</h3>
            <p className="section-text">
              The following items cannot be returned:
            </p>
            <ul className="section-list">
              <li>Items purchased more than 30 days ago</li>
              <li>Items that show signs of use or wear</li>
              <li>Items that have been washed or altered</li>
              <li>Items without original tags or packaging</li>
              <li>
                Clearance or final sale items (marked as such at purchase)
              </li>
            </ul>
          </section>

          <section className="policy-section">
            <h3 className="section-title">7. Damaged or Defective Items</h3>
            <p className="section-text">
              If you receive a damaged or defective item, please contact us
              immediately with photos of the damage. We will replace the item or
              issue a full refund, including original shipping costs. No return
              shipping will be required for defective items.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">8. International Returns</h3>
            <p className="section-text">
              International customers are responsible for return shipping costs.
              Please contact us at trade@liiskerlane.digital for a return
              address and instructions. Refunds will be processed once we
              receive and inspect your return, minus the cost of return
              shipping.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">9. Return Shipping</h3>
            <p className="section-text">
              For domestic returns, we provide a prepaid return shipping label.
              Please pack your item securely and use the provided label. For
              international returns, you will need to arrange and pay for
              shipping to our return address.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">10. Tracking Your Return</h3>
            <p className="section-text">
              Once you ship your return, you can track it using the tracking
              number provided. We recommend using a tracked shipping method so
              you can confirm delivery.
            </p>
          </section>

          <section className="policy-section">
            <h3 className="section-title">11. Questions or Issues</h3>
            <p className="section-text">
              If you have any questions about our return policy or need
              assistance with a return, please don't hesitate to contact us:
            </p>
            <div className="contact-info">
              <p>
                <strong>Email:</strong> trade@liiskerlane.digital
              </p>

              <p>
                <strong>Hours:</strong> Monday - Friday, 9am - 5pm EST
              </p>
            </div>
          </section>

          <section className="policy-section">
            <h3 className="section-title">12. Satisfaction Guarantee</h3>
            <p className="section-text">
              Your satisfaction is our top priority. If you're not completely
              happy with your purchase for any reason, we're here to make it
              right. Contact us and we'll work with you to find a solution.
            </p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Returns;
